import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { FormBuilder, FormControl, FormGroup, Validator, Validators} from '@angular/forms';
import {AlertService} from 'src/app/_services/alert.service';
import { StorageService } from 'src/app/_services/storage.service';
import {getAllErrors, moreThanOneWhiteSpaceValidator} from 'src/app/common/common.validators';
import {DataTable} from "simple-datatables";
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { TitleCasePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { ApiHttpService } from 'src/app/_services/api-http.service';
import { MerchantService } from '../merchant-master/merchant.service';
import { environment } from 'src/environments/environment';
const {API_URL} = environment;

@Component({
  selector: 'app-merchant-contract-generation',
  templateUrl: './merchant-contract-generation.component.html',
  styleUrls: ['./merchant-contract-generation.component.scss']
})
export class MerchantContractGenerationComponent implements OnInit {

  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  // merchatstatusform: FormGroup;
  isForm1Submitted: boolean;
  @Input() merchantStatusConfig: any;
  @Input() onMerchantMId: EventEmitter<any> = new EventEmitter<any>();
  data: any;
  merchantId: any
  loading: boolean =false;
  remarkData: any=[];
  loader: any = false;
  pageSize: number = 10;
  status : any;
  contractPdf: any;
  mobileNumber: any;
  constructor(private services: ApiHttpService,private router : Router, private alertService: AlertService, private formbuilder: FormBuilder,private storage:StorageService,private merchantService: MerchantService) {

    this.data = this.merchantStatusConfig
  }

  // get form1() {
  //   return this.merchatstatusform.controls;
  // }

  ngOnInit(): void {

    this.onMerchantMId.subscribe((res) => {
      console.log(res)
      this.merchantId = res.mobile,
      this.status = res.walletStatus,
      this.mobileNumber = res.mobileNumber,
      this.loading = false,
      this.isForm1Submitted = false

      this.merchantService.getOnboardingRemark(this.merchantId,"Status")
              .subscribe((data: any) => {
                console.log(data);
                this.remarkData = data.response.data;
              })

      this.loadContractPdf();
    }

      )

  }

  loadContractPdf(): void {
    this.merchantService.getMerchantContractPdf(this.mobileNumber).subscribe(
      (data: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.body);
        reader.onloadend = () => {
          this.contractPdf = reader.result;
        };
      },
      (error: any) => {
        console.error('Failed to load contract PDF:', error);
        this.alertService.errorAlertWithMessage('Unable to load contract document');
      }
    );
  }
  saveContract(){
    debugger;
    const data={
      "userId":this.merchantId,
      "status":this.status,
      // "contract":this.merchatstatusform.get('contract')?.value
    }
    this.merchantService.pushContractNotification(data).subscribe(
    (response: any) => {
      console.log('Notification Response:', response);

      if (response && response.response) {
        console.log(response.response.message);
        if(response.response.status==200){
            this.alertService.successAlert(
              "Status successfully updated"
            )
            this.isForm1Submitted = false;
            this.closeModal.emit({
              showModal: false
            })
          }
      }
    },
    (error) => {
      console.error('Failed to send notification:', error);
    }
  );
  }

}
